import { render } from "./InfoPageView.vue?vue&type=template&id=157474ed&scoped=true"
import script from "./InfoPageView.vue?vue&type=script&lang=js"
export * from "./InfoPageView.vue?vue&type=script&lang=js"

import "./InfoPageView.vue?vue&type=style&index=0&id=157474ed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157474ed"]])

export default __exports__